import React from "react";

/**
 * A card's title and the line under it, for every card of the detail. The line sits a
 * step under the title (CTX-1527): with both at 14 px only the weight told them apart,
 * the titles lost the lead and the cards read heavy (review of 27-oct). One component,
 * so the cards cannot drift apart again.
 */
export default function CardHeading({
    title,
    subtitle,
    className,
}: {
    title: string;
    /** One line under the title: what the card measures, or how to use it. */
    subtitle?: React.ReactNode;
    className?: string;
}) {
    return (
        <div className={className}>
            <h3 className="text-sm font-semibold">{title}</h3>
            {subtitle ? <p className="text-xs text-semantic-text-secondary">{subtitle}</p> : null}
        </div>
    );
}
